import React from 'react'

const NotFoundPage = () =>
  <div>
    <h1>NOT FOUND</h1>
  </div>

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js